<script>
import {useI18n} from "vue-i18n";
import OverviewPanel from "@/javascript/views/clientDashboard/overview/Overview.vue";
import DonationsPanel from "@/javascript/views/clientDashboard/donations/Donations.vue";
import DonorsPanel from "@/javascript/views/clientDashboard/donors/Donors.vue";
import PaymentProcessorsPanel from "@/javascript/views/clientDashboard/payment/PaymentProcessorPanel.vue";
import TeamPanel from "@/javascript/views/clientDashboard/team/Team.vue";
import PersonalSettingsPanel from "@/javascript/views/clientDashboard/settings/Personal.vue";
import OrganizationSettingsPanel from "@/javascript/views/clientDashboard/settings/Organization.vue";
import CampaignsPanel from "./campaigns/Campaign.vue";
import FundsPanel from "@/javascript/views/clientDashboard/funds/Fund.vue";
import HouseholdShowPanel from "@/javascript/views/clientDashboard/households/HouseholdShow.vue";
import Icon from "@/javascript/views/components/Icon.vue";
import DropdownSelect from "@/javascript/views/components/dropdownSelect.vue";
import {useRoute, useRouter} from "vue-router";
import {useUserStore} from "../../stores/user";
import {useDemoLoopStore} from "../../stores/demoLoop";
import LoadingSpinner from "@/javascript/views/components/loadingSpinner.vue";
import {useDonorStore} from "@/javascript/stores/donor";
import {useOrgMemberStore} from "@/javascript/stores/orgMember";
import {useDonationStore} from "../../stores/donation";
import {useOrganizationStore} from "../../stores/organizations";
import {usePaymentProcessorStore} from "../../stores/paymentProcessors";
import {useFundStore} from "../../stores/fund";
import {useOverviewStore} from "../../stores/overview";
import {useCampaignStore} from "../../stores/campaign";
import {useSubscriptionStore} from "../../stores/subscription";
import LandingPageBuilder from "./landingBuilder/LandingBuilder.vue";
import {useLandingPageStore} from "../../stores/landingPage";
import {useAnalyticEventStore} from "@/javascript/stores/analyticEvents";
import AccordionItem from "../components/accordion/AccordionItem.vue";
import DonationManagement from "../donorDashboard/donorProfile/DonationManagement.vue";
import DonorProfile from "../donorDashboard/donorProfile/DonorProfile.vue";
import DashboardHeader from "../components/dashboard/DashboardHeader.vue";
import OrganizationSelector from "./OrganizationSelector.vue";
import Drawer from "../components/Drawer.vue";
import {ApiService} from "../../services/api.service";
import ReportsPanel from "./reports/Reports.vue";
import {useReportStore} from "../../stores/report";

export default {
  components: {
    ReportsPanel,
    Drawer,
    OrganizationSelector,
    DashboardHeader,
    DonorProfile,
    DonationManagement,
    AccordionItem,
    LandingPageBuilder,
    CampaignsPanel,
    FundsPanel,
    HouseholdShowPanel,
    DonationsPanel,
    OverviewPanel,
    DonorsPanel,
    PaymentProcessorsPanel,
    TeamPanel,
    PersonalSettingsPanel,
    OrganizationSettingsPanel,
    Icon,
    DropdownSelect,
    LoadingSpinner,

  },
  props: {},
  setup() {
    // Stores
    const userStore = useUserStore();
    const overviewStore = useOverviewStore();
    const donorStore = useDonorStore();
    const memberStore = useOrgMemberStore();
    const donationStore = useDonationStore();
    const subscriptionStore = useSubscriptionStore();
    const campaignStore = useCampaignStore();
    const organizationStore = useOrganizationStore();
    const processorStore = usePaymentProcessorStore();
    const fundStore = useFundStore();
    const landingBuilderStore = useLandingPageStore();
    const reportStore = useReportStore();
    const analyticEventStore = useAnalyticEventStore();
    const demoLoopStore = useDemoLoopStore();


    // I18n
    const {t} = useI18n();

    // Router
    const router = useRouter();
    const route = useRoute();

    return {
      t,
      router,
      route,
      userStore,
      overviewStore,
      donorStore,
      memberStore,
      donationStore,
      subscriptionStore,
      campaignStore,
      fundStore,
      organizationStore,
      processorStore,
      landingBuilderStore,
      reportStore,
      analyticEventStore,
      demoLoopStore
    };
  },
  data() {
    return {

      panels: [
        'overview',
        'donors',
        'duplicate-donors',
        'households',
        'team',
        'gifts',
        'recurring-gifts',
        'payment_processors',
        'design-hub',
        'funds',
        'campaigns',
        'reports',
        "personal_settings",
        "organization_settings",
        "notifications"
      ],
      settingsOptions: [
        {name: "Personal", value: "personal_settings"},
        {name: "Organization", value: "organization_settings"},
      ],
      isSidebarCollapsed: false,
      showLinksPopup: false,
      hoverTimeout: null,
      showOrgPopup: false,
      repaymentBanner: {
        show: false,
        dismissed: false,
        windowInfo: {
          open: false,
          quarter: null,
          months: [],
          quarter_year: null,
          window_start: null,
          window_end: null,
          next_window_date: null,
          submitted: false,
        },
      },
    };
  },
  computed: {
    activePanel() {
      return this.route.params.panel;
    },
    loading() {
      return this.userStore.user === null || this.userStore.currentOrganization === null;
    },
    tabPermissions() {
      return this.organizationStore.pagePermissions;
    },
    showOrganizationSwitcher() {
      return this.userStore.organizations.length > 1;
    },
    showRepaymentBanner() {
      if (this.repaymentBanner.dismissed) return false;
      if (!this.repaymentBanner.show) return false;
      // Do not show if it has been submitted
      if (this.repaymentBanner.windowInfo?.submitted) return false;
      // only show on overview
      if (this.activePanel !== 'overview') return false;
      if (!this.hasActiveHelcimAccount) return false;
      return true;
    },
    repaymentDeadline() {
      if (!this.repaymentBanner.windowInfo?.window_end) return '';
      const closeDate = new Date(this.repaymentBanner.windowInfo.window_end + 'T00:00:00');
      closeDate.setDate(closeDate.getDate() - 1);
      return closeDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    },
    repaymentQuarter() {
      const months = this.repaymentBanner.windowInfo?.months;
      if (!months || months.length === 0) return '';
      return months.join(', ');
    },
    hasActiveHelcimAccount() {
      const helcimProcessor = this.processorStore.getProcessorByType('HELCIM');
      return !!helcimProcessor && helcimProcessor.active;
    }
  },
  watch: {
    'userStore.currentOrganization'(newOrg, oldOrg) {
      if (oldOrg && oldOrg.uuid !== newOrg?.uuid) {
        this.updateUrl('overview');
      }
      this.updateStoreIds(this.userStore.currentOrganization?.id);
      this.organizationStore.getPagePermissions();
      this.organizationStore.getOrganization();
    },
    'organizationStore.organization'(organization) {
      this.landingBuilderStore.organization = organization;
    },
    'organizationStore.organizationId'() {
      this.repaymentBanner.show = false;
      this.repaymentBanner.dismissed = false;
      this.repaymentBanner.windowInfo = {
        open: false,
        quarter: null,
        months: [],
        quarter_year: null,
        window_start: null,
        window_end: null,
        next_window_date: null,
        submitted: false,
      };
      this.fetchRepaymentWindowStatus();
    }
  },

  mounted() {
    requestAnimationFrame(() => {
      this.loadData();
      this.screenResize();
      document.addEventListener('click', this.screenClick);
      window.addEventListener('resize', this.screenResize);
    });
  },

  methods: {
    async fetchRepaymentWindowStatus() {
      try {
        const orgId = this.organizationStore.organizationId;
        if (!orgId) return;

        // Reload processors for the current org (runs on load + org switch only)
        await this.processorStore.getOrgPaymentProcessors();
        if (!this.hasActiveHelcimAccount) return;

        const api = new ApiService();
        let url = `/organizations/${orgId}/processor/repayment_submissions/window_status`;
        const urlParams = new URLSearchParams(window.location.search);
        const testDate = urlParams.get('test_date');
        if (testDate) url += `?test_date=${testDate}`;

        const response = await api.get(url);
        const data = response.json || response;
        this.repaymentBanner.windowInfo = data;
        this.repaymentBanner.show = data.open;
      } catch (e) {
        // Silently fail. Banner just won't show
      }
    },

    dismissRepaymentBanner() {
      this.repaymentBanner.dismissed = true;
    },

    switchOrganization(org) {
      this.$refs.orgSwitcherDrawer.hide();
      this.userStore.currentOrganization = org;
      this.updateStoreIds(org.id);
      this.organizationStore.getPagePermissions();
      this.organizationStore.getOrganization();
      this.hidePopups();
      this.updateUrl('overview');
    },

    loadData() {
      this.userStore.userId = document.body.dataset.currentUserId;
      this.analyticEventStore.userId = document.body.dataset.currentUserId;

      this.userStore.loadData(this.$route.params.org).then((res) => {
        // Reroute to base URL of TOS not agreed to.
        if (!this.userStore.userAgreedToAllTerms) {
          this.router.push({path: '/'});
          return;
        }
        if (res) {
          this.organizationStore.getOrganization().then(() => {
            if (this.userStore.organizations.length === 0) {
              // If user is not an org member, redirect to super admin (if admin)
              if (this.userStore.userIsAdmin) {
                this.goToAdmin();
              } else {
                // Redirect to donor dashboard if no org permissions
                this.goToDonorDashboard();
              }
            } else {
              this.updateStoreIds(this.userStore.currentOrganization?.id);
              if (!this.activePanel) {
                this._switchPanel(this.$route.params.panel ? this.$route.params.panel : 'overview');
              }
            }
          });

        }
      });
    },

    showTab(tab) {
      return this.tabPermissions && this.tabPermissions[tab];
    },

    updateStoreIds(organizationId) {
      this.organizationStore.setOrganizationId(organizationId);
      this.overviewStore.setOrganizationId(organizationId);
      this.donorStore.setOrganizationId(organizationId);
      this.memberStore.setOrganizationId(organizationId);
      this.donationStore.setOrganizationId(organizationId);
      this.subscriptionStore.setOrganizationId(organizationId);
      this.campaignStore.setOrganizationId(organizationId);
      this.fundStore.setOrganizationId(organizationId);
      this.processorStore.setOrganizationId(organizationId);
      this.landingBuilderStore.setOrganizationId(this.userStore.currentOrganization?.slug ?? organizationId);
      this.reportStore.setOrganizationId(organizationId);
      this.analyticEventStore.setOrganizationId(organizationId);
      this.analyticEventStore.logEvent({
        action: `dashboard-change-organization`
      });
    },

    updateUrl(panel) {
      if (this.userStore.userScopedToSubdomain) {
        this.$router.push({
            name: "client-dashboard-scoped",
            params: {
              panel: panel,
              id: null
            }
          }
        );
      } else {
        this.$router.push(
          {
            name: "client-dashboard",
            params: {
              panel: panel,
              org: this.userStore.currentOrganization?.slug,
              id: null
            }
          });
      }

    },

    changePanel(panel) {
      if (
        this.activePanel === 'design-hub' &&
        this.$refs.landingBuilder &&
        (this.$refs.landingBuilder.landingStore.dirtyDraft || this.$refs.landingBuilder.landingStore.brandDirty)
      ) {
        this.$refs.landingBuilder.showUnsavedModal(() => {
          this._switchPanel(panel);
        });
        return;
      }
      this._switchPanel(panel);
    },

    _switchPanel(panel) {
      if (this.panels.includes(panel)) {
        this.updateUrl(panel);
        this.closeDropdowns();
        this.analyticEventStore.logEvent({
          action: `dashboard-switch-panel-${panel}`
        });
      }
    },

    signOut() {
      this.userStore.signOut();
    },

    goToAdmin() {
      this.userStore.goToAdmin();
    },

    goToDonorDashboard() {
      this.router.push(
        {
          name: "donor-dashboard",
          params: {
            panel: 'profile',
            org: this.userStore.currentOrganization?.slug,
          }
        });
    },
    openDemoLoop() {
      this.demoLoopStore.pickerContext = 'client-dashboard';
      this.demoLoopStore.pickerOpen = true;
    },

    openDonationLink() {
      const route = this.router.resolve(
        {
          name: 'donation-form', params: {
            org: this.route.params.org
          }
        },
      );
      window.open(route.href, '_blank');
    },

    openLandingPageLink() {
      const route = this.router.resolve(
        {
          name: 'landing', params: {
            org: this.route.params.org
          }
        },
      );
      window.open(route.href, '_blank');
    },

    openDrawer() {
      this.$refs.orgSwitcherDrawer.show();
      this.$refs.orgSwitcherDrawer.toggleFullScreen(true);
    },

    closeDrawer() {
      this.$refs.orgSwitcherDrawer.hide();
    },

    // Close the settings menu when you click off
    screenClick(event) {
      if (this.$refs.linksButton && !this.$refs.linksButton.$el.contains(event.target)) {
        this.$refs.linksButton.collapse();
      }

      if (this.$refs.dashHeader && !this.$refs.dashHeader.$el.contains(event.target)) {
        this.$refs.dashHeader.closeMenu();
      }

      // Close links popup if clicked outside
      if (this.showLinksPopup) {
        const popup = this.$refs.linksPopup;
        const linksButton = this.$refs.linksIconButton;
        if (popup && !popup.contains(event.target) && !(linksButton && linksButton.contains(event.target))) {
          this.showLinksPopup = false;
        }
      }

      if (this.showOrgPopup) {
        const popup = this.$refs.orgPopup;
        const orgButton = this.$refs.orgSwitcherButton;
        if (popup && !popup.contains(event.target) && !(orgButton && orgButton.contains(event.target))) {
          this.showOrgPopup = false;
        }
      }

    },

    screenResize() {
      this.closeDropdowns();
      if (window.innerWidth < 768) {
        this.isSidebarCollapsed = true;
      }
    },

    closeDropdowns() {
      if (this.$refs.linksButton) {
        this.$refs.linksButton.collapse();
        this.$refs.dashHeader.closeMenu();
      }
    },

    hidePopups() {
      this.showLinksPopup = false;
      this.showOrgPopup = false;
    },

    onLinksEnter() {
      clearTimeout(this.hoverTimeout);
      this.hidePopups();
      this.showLinksPopup = true;

      this.$nextTick(() => {
        if (this.$refs.linksIconButton) {
          const rect = this.$refs.linksIconButton.getBoundingClientRect();
          this.linksPopupTop = rect.top + window.scrollY;
        }
      });
    },

    onLinksLeave() {
      this.hoverTimeout = setTimeout(() => {
        this.showLinksPopup = false;
      }, 200); // short delay to avoid flicker
    },
  }
};
</script>

<template>
  <div
    v-if="loading"
    class="flex justify-center items-center h-screen"
  >
    <loading-spinner size="small" />
  </div>
  <div
    v-else
    class="dashboard-container"
  >
    <dashboard-header
      ref="dashHeader"
      :collapsed="isSidebarCollapsed"
      class="flex-shrink-0"
      fallback="name"
      :ignore-org="false"
      title=""
    >
      <template #nav-menu-items>
        <nav class="nav-menu">
          <div
            v-if="showOrganizationSwitcher"
            class="nav-item flex flex-row justify-between"
            @click="openDrawer"
          >
            <div>Switch Organization</div>
            <icon
              icon="sitemap"
              color="#4f4f4f"
            />
          </div>
          <div
            v-if="userStore.userIsAdmin"
            class="nav-item flex flex-row justify-between"
            @click="goToAdmin"
          >
            <div>Backend Admin</div>
          </div>
          <div
            class="nav-item flex flex-row justify-between"
            @click="goToDonorDashboard"
          >
            <div>Donor Dashboard</div>
          </div>

          <!-- Removed click to toggle so icon can be pressed-->
          <div
            class="nav-item flex flex-row justify-between"
            @click="$refs.settingsButton.toggle()"
          >
            <accordion-item
              ref="settingsButton"
              no-chevron
              full-width
              no-border
              no-padding
              class="w-full pointer-events-none"
            >
              <template #titleSlot>
                <div class="flex flex-row justify-between w-full">
                  <span class="transition-all duration-200">
                    {{ t("admin.controls.settings") }}
                  </span>
                  <icon
                    icon="gear"
                    color="#4f4f4f"
                  />
                </div>
              </template>
              <template #bodySlot>
                <ul class="mt-2 pointer-events-auto">
                  <li
                    v-for="option in settingsOptions"
                    :key="option.value"
                    class="cursor-pointer px-4 py-2 hover-item hover:bg-gray-100 "
                    @click="changePanel(option.value); $event.stopPropagation()"
                  >
                    {{ option.name }}
                  </li>
                </ul>
              </template>
            </accordion-item>
          </div>
          <div
            class="nav-item flex flex-row justify-between"
            @click="openDemoLoop"
          >
            <div>Demo Tour</div>
            <icon
              icon="play"
              color="#4f4f4f"
            />
          </div>
          <div
            class="nav-item flex flex-row justify-between"
            @click="userStore.signOut"
          >
            <div>Sign Out</div>
            <icon
              icon="logout"
              color="#4f4f4f"
            />
          </div>
        </nav>
      </template>
    </dashboard-header>

    <div
      class="content-container"
    >
      <!-- Sidebar Toggle Button -->
      <div
        class="sidebar-toggle-button"
        :class="[
          isSidebarCollapsed
            ? 'left-[60px]' // <= match collapsed sidebar width
            : 'left-[60px] sm:left-[80px] md:left-[256px]' // <= match expanded sidebar width
        ]"
      >
        <div
          class="w-6 h-14 bg-white rounded-r-md flex items-center justify-center cursor-pointer"
          aria-label="Toggle Sidebar"
          @click="isSidebarCollapsed = !isSidebarCollapsed"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-gray-600 transition-transform duration-200"
            :class="isSidebarCollapsed ? 'rotate-0' : 'rotate-180'"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </div>

      <!-- Sidebar -->
      <div
        class="admin-sidebar-container"
        :class="[
          isSidebarCollapsed ? 'w-[60px]' : 'w-[60px] sm:w-[80px] md:w-64'
        ]"
      >
        <div
          :class="[
            'admin-sidebar h-full max-h-screen transition-all duration-300 overflow-y-visible',
            isSidebarCollapsed ? 'w-[60px] collapsed-sidebar' : 'expanded w-[60px] sm:w-[80px] md:w-64'
          ]"
        >
          <ul>
            <li
              :class="{ 'selected': activePanel === 'overview' }"
              class="sidebar-item mt-8"
              @click="changePanel('overview')"
            >
              <icon icon="dashboard" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.overview') }}
              </span>
            </li>
            <li
              v-if="showTab('donors')"
              class="sidebar-divider"
            />
            <li
              v-if="showTab('donors')"
              :class="{ 'selected': activePanel === 'donors' || activePanel === 'duplicate-donors' }"
              class="sidebar-item"
              @click="changePanel('donors')"
            >
              <icon icon="user-avatar" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.donors') }}
              </span>
            </li>
            <!--   Linking with Donors - if you cant see Donors, you should not be able to see Households-->
            <li
              v-if="showTab('donors')"
              :class="{ 'selected': activePanel === 'households' }"
              class="sidebar-item"
              @click="changePanel('households')"
            >
              <icon icon="house-solid-full" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.households') }}
              </span>
            </li>
            <li
              v-if="showTab('team')"
              :class="{ 'selected': activePanel === 'team' }"
              class="sidebar-item"
              @click="changePanel('team')"
            >
              <icon icon="team" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.team') }}
              </span>
            </li>
            <li class="sidebar-divider" />
            <li
              :class="{ 'selected': activePanel === 'funds' }"
              class="sidebar-item"
              @click="changePanel('funds')"
            >
              <icon icon="fund" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.funds') }}
              </span>
            </li>
            <li
              :class="{ 'selected': activePanel === 'campaigns' }"
              class="sidebar-item"
              @click="changePanel('campaigns')"
            >
              <icon icon="ribbon" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.campaigns') }}
              </span>
            </li>
            <li
              v-if="showTab('donations')"
              class="sidebar-divider"
            />
            <li
              v-if="showTab('donations')"
              :class="{ 'selected': activePanel === 'gifts' || activePanel === 'recurring-gifts' }"
              class="sidebar-item"
              @click="changePanel('gifts')"
            >
              <icon icon="hand-heart" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.donations') }}
              </span>
            </li>
            <li
              v-if="showTab('payment_processors')"
              :class="{ 'selected': activePanel === 'payment_processors' }"
              class="sidebar-item"
              @click="changePanel('payment_processors')"
            >
              <icon icon="credit-card" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.payment_processors') }}
              </span>
            </li>
            <li
              v-if="showTab('reporting')"
              :class="{ 'selected': activePanel === 'reports' }"
              class="sidebar-item"
              @click="changePanel('reports')"
            >
              <icon icon="chart-pie" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.reports') }}
              </span>
            </li>

            <li class="sidebar-divider" />
            <li
              :class="{ 'selected': activePanel === 'design-hub' }"
              class="sidebar-item"
              @click="changePanel('design-hub')"
            >
              <icon icon="template" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.landing_builder') }}
              </span>
            </li>

            <li class="relative sidebar-accordion-item">
              <!-- Collapsed Mode (floating popup) -->
              <template v-if="isSidebarCollapsed">
                <div
                  ref="linksIconButton"
                  class="sidebar-item flex justify-center items-center h-10 cursor-pointer"
                  @mouseenter="onLinksEnter"
                  @mouseleave="onLinksLeave"
                  @click="showLinksPopup = !showLinksPopup"
                >
                  <icon icon="donation-link-icon" />
                </div>
              </template>

              <!-- Expanded Mode (accordion dropdown) -->
              <template v-else>
                <accordion-item
                  ref="linksButton"
                  click-to-toggle
                  full-width
                  no-border
                  no-padding
                  class="w-full"
                >
                  <template #titleSlot>
                    <div class="flex flex-row px-4 py-2">
                      <icon icon="donation-link-icon" />
                      <span class="panel-label font-bold transition-all duration-200 pl-4">Pages</span>
                    </div>
                  </template>
                  <template #bodySlot>
                    <ul>
                      <li
                        class="cursor-pointer px-4 py-2 hover-item"
                        @click="openLandingPageLink"
                      >
                        Landing Page
                      </li>
                      <li
                        class="cursor-pointer px-4 py-2 hover-item"
                        @click="openDonationLink"
                      >
                        Giving Form
                      </li>
                    </ul>
                  </template>
                </accordion-item>
              </template>
            </li>
          </ul>

          <div class="flex-1 min-h-0" />
          <ul>
            <!-- Notifications Panel (Commented out, now updated if re-enabled) -->
            <!--
            <li
              :class="{ 'selected': activePanel === 'notifications' }"
              class="sidebar-item"
              @click="changePanel('notifications')"
            >
              <icon icon="paper-plane" />
              <span
                class="panel-label font-bold transition-all duration-200"
                :class="{
                  'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,
                  'pl-4 md:inline-block': !isSidebarCollapsed
                }"
              >
                {{ t('admin.panels.notifications') }}
              </span>
            </li>
            -->

            <!-- SETTINGS -->
            <!-- Make this a component if we do any more of these -->
            <!--            <li class="relative sidebar-accordion-item">-->
            <!--              &lt;!&ndash; Collapsed Mode (floating popup) &ndash;&gt;-->
            <!--              <template v-if="isSidebarCollapsed">-->
            <!--                <div-->
            <!--                  class="sidebar-item flex justify-center items-center h-10 cursor-pointer"-->
            <!--                  @mouseenter="onSettingsEnter"-->
            <!--                  @mouseleave="onSettingsLeave"-->
            <!--                  @click="showSettingsPopup = !showSettingsPopup"-->
            <!--                  ref="gearIconButton"-->
            <!--                >-->
            <!--                  <icon icon="gear"/>-->
            <!--                </div>-->


            <!--              </template>-->

            <!--              &lt;!&ndash; Expanded Mode (accordion dropdown) &ndash;&gt;-->
            <!--              <template v-else>-->
            <!--                <accordion-item-->
            <!--                  ref="settingsButton"-->
            <!--                  click-to-toggle-->
            <!--                  full-width-->
            <!--                  no-border-->
            <!--                  no-padding-->
            <!--                  class="w-full"-->
            <!--                >-->
            <!--                  <template #titleSlot>-->
            <!--                    <div class="flex flex-row px-4 py-2">-->
            <!--                      <icon icon="gear"/>-->
            <!--                      <span class="panel-label font-bold transition-all duration-200 pl-4">-->
            <!--                    {{ t("admin.controls.settings") }}-->
            <!--                  </span>-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                  <template #bodySlot>-->
            <!--                    <ul>-->
            <!--                      <li-->
            <!--                        v-for="option in settingsOptions"-->
            <!--                        :key="option.value"-->
            <!--                        class="cursor-pointer px-4 py-2 hover-item"-->
            <!--                        @click="changePanel(option.value); $event.stopPropagation()"-->
            <!--                      >-->
            <!--                        {{ option.name }}-->
            <!--                      </li>-->
            <!--                    </ul>-->
            <!--                  </template>-->
            <!--                </accordion-item>-->
            <!--              </template>-->
            <!--            </li>-->

            <!--            &lt;!&ndash; Logout &ndash;&gt;-->
            <!--            <li-->
            <!--              class="cursor-pointer px-4 py-2 mt-2"-->
            <!--              @click="userStore.signOut"-->
            <!--            >-->
            <!--              <icon icon="logout"/>-->
            <!--              <span-->
            <!--                class="panel-label font-bold transition-all duration-200"-->
            <!--                :class="{-->
            <!--              'opacity-0 w-0 overflow-hidden': isSidebarCollapsed,-->
            <!--              'pl-4 md:inline-block': !isSidebarCollapsed-->
            <!--            }"-->
            <!--              >-->
            <!--            {{ t("admin.controls.logout") }}-->
            <!--          </span>-->
            <!--            </li>-->
          </ul>
        </div>
        <!--      SETTINGS POPUP-->
        <!--        <div-->
        <!--          v-if="showSettingsPopup"-->
        <!--          ref="settingsPopup"-->
        <!--          class="nav-popup-menu top-[calc(100vh-140px)]"-->
        <!--          @mouseenter="onSettingsEnter"-->
        <!--          @mouseleave="onSettingsLeave"-->
        <!--        >-->
        <!--          <ul class="text-gray-800 text-sm">-->
        <!--            <li-->
        <!--              v-for="option in settingsOptions"-->
        <!--              :key="option.value"-->
        <!--              class="px-4 py-2 hover:bg-gray-100 cursor-pointer"-->
        <!--              @click="selectSettingsOption(option.value)"-->
        <!--            >-->
        <!--              {{ option.name }}-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </div>-->

        <!--      NAV LINKS POPUP-->

        <div
          v-if="showLinksPopup"
          ref="linksPopup"
          class="nav-popup-menu"
          :style="{ top: `${linksPopupTop}px` }"
          @mouseenter="onLinksEnter"
          @mouseleave="onLinksLeave"
        >
          <ul class="text-gray-800 text-sm">
            <li
              class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              @click="openLandingPageLink"
            >
              Landing Page
            </li>
            <li
              class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              @click="openDonationLink"
            >
              Giving Form
            </li>
          </ul>
        </div>
      </div>

      <!-- Main Content -->
      <div
        :class="[
          'dashboard-panel-content clean-scrollbar',
          isSidebarCollapsed ? 'w-full' : 'w-4/5'
        ]"
      >
        <!-- Repayment Reminder Banner -->
        <div
          v-if="showRepaymentBanner"
          class="repayment-banner"
        >
          <div class="flex items-center gap-3 flex-1">
            <i class="fa-solid fa-file-invoice text-lg" />
            <div>
              <p class="font-semibold text-sm">Repayment Submission Open ({{ repaymentQuarter }})</p>
              <p class="text-sm opacity-90">Submit your documents by {{ repaymentDeadline }}</p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <button
              class="repayment-banner-link"
              @click="changePanel('payment_processors'); dismissRepaymentBanner()"
            >
              Submit Documents
            </button>
            <button
              class="repayment-banner-dismiss"
              @click="dismissRepaymentBanner"
            >
              <i class="fa-solid fa-xmark" />
            </button>
          </div>
        </div>

        <overview-panel
          v-if="activePanel === 'overview'"
        />
        <donors-panel
          v-else-if="activePanel === 'donors' || activePanel === 'duplicate-donors'"
        />
        <household-show-panel
          v-else-if="activePanel === 'households'"
        />
        <team-panel
          v-else-if="activePanel === 'team'"
        />
        <donations-panel
          v-else-if="activePanel === 'gifts' || activePanel === 'recurring-gifts'"
        />
        <funds-panel
          v-else-if="activePanel === 'funds'"
        />
        <campaigns-panel
          v-else-if="activePanel === 'campaigns'"
        />
        <payment-processors-panel
          v-else-if="activePanel === 'payment_processors'"
        />
        <reports-panel
          v-else-if="activePanel === 'reports'"
        />
        <landing-page-builder
          v-else-if="activePanel === 'design-hub'"
          ref="landingBuilder"
        />
        <personal-settings-panel
          v-else-if="activePanel === 'personal_settings'"
        />
        <organization-settings-panel
          v-else-if="activePanel === 'organization_settings'"
          :org-id="userStore.currentOrganization.id"
        />
        <!-- No Match (only when a panel param is present but unrecognized) -->
        <div
          v-else-if="activePanel && !panels.includes(activePanel)"
          class="flex flex-col items-center justify-center h-full py-20 text-center"
        >
          <h2 class="text-2xl font-bold text-gray-700 mb-2">
            Page not found
          </h2>
          <p class="text-gray-500 mb-6">
            Sorry, the page you're looking for doesn't exist.
          </p>
          <button
            class="px-4 py-2 bg-default_primary text-white rounded hover:bg-default_primary_dark"
            @click="changePanel('overview')"
          >
            Back to Overview
          </button>
        </div>
      </div>
    </div>
  </div>

  <drawer
    ref="orgSwitcherDrawer"
    size="large"
    hide-close-button
  >
    <organization-selector
      @organization-selected="switchOrganization"
      @close="closeDrawer"
    />
  </drawer>
</template>

<style lang="scss">
@import '@/styles/_variables.scss';

.repayment-banner {
  @apply flex items-center justify-between px-4 py-3 mx-4 mt-4 rounded-lg;
  background-color: #FCF2E6 ;
  border: 1px solid #E7A24D;
  color: #854901;
}

.repayment-banner-link {
  @apply text-sm font-semibold px-3 py-1.5 rounded;
  background-color: #854901 ;
  color: white;
  border: none;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: #9F5801;
  }
}

.repayment-banner-dismiss {
  @apply text-lg opacity-60;
  background: none;
  border: none;
  cursor: pointer;
  color: #1a4971;

  &:hover {
    opacity: 1;
  }
}

.dashboard-container {
  @apply h-dvh max-h-dvh flex flex-col overflow-hidden;

  .admin-sidebar-container {
    @apply h-full max-h-screen relative transition-all duration-300 border-r;
  }

  .content-container {
    @apply flex flex-row flex-1 overflow-x-auto;
  }

  .dashboard-panel-content {
    @apply flex-1 bg-gray-100  transition-all duration-300;
    @apply overflow-auto h-full;

    scrollbar-width: none;
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
}

.nav-popup-menu {
  position: absolute;
  left: 65px;
  @apply bg-white rounded-lg shadow-lg py-2 z-[9999] w-48;
  border: 1px solid gray;
}

.collapsed-sidebar {
  padding-left: 0;
  padding-right: 0;

  li {
    padding-left: 0;
    padding-right: 0;
    justify-content: center;
    @apply mx-1;
  }

  .sidebar-item {
    padding-left: 0;
    padding-right: 0;
    justify-content: center;
    @apply rounded-md;
  }

  .panel-label,
  .donation-link {
    display: none !important; // Hide text labels fully
  }
}


:deep(.accordion-chevron) {
  @apply mr-2;
}

.admin-sidebar {
  @apply pt-2 pb-4 px-0;
  // force no padding on collapse manually
  @apply flex flex-col;
  overflow-x: hidden;

  &.expanded {
    @apply px-2;
  }

  li {
    @apply flex items-center text-slate-600;
    @apply md:rounded;
  }

  .sidebar-item {
    @apply cursor-pointer;
    @apply px-4;
    @apply py-2;
    @apply mb-2;
  }

  .sidebar-item.selected {
    @apply bg-default_primary text-default_white;

    .icon svg path {
      @apply fill-default_white;
    }
  }

  .sidebar-item:hover,
  .hover-item:hover {
    @apply bg-default_primary_dark text-default_white;

    .icon svg path {
      @apply fill-default_white;
    }
  }

  .panel-label,
  .donation-link {
    @apply pl-4 hidden md:block font-bold;
  }

  .icon svg path {
    @apply fill-default_primary;
  }

  .settings-dropdown-menu {
    position: absolute;
    bottom: 125px;
    left: 30px;
    margin-top: 8px;
    z-index: 100;
    width: 200px;
  }
}

.admin-sidebar .sidebar-divider {
  @apply bg-slate-400;
  @apply my-4;
  width: 100%;
  height: 1px;
}

.dropdown-mb {
  @apply mb-16;
}

.dashboard-dropdown .selected span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  line-height: 1.2em;
  max-height: 2.4em;
}

.org-popup-li {
  display: block !important;
  width: 100%;
  padding: 0.5rem $space-4x;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  margin: 0 !important;
  justify-content: flex-start !important;
}

.collapsed-sidebar .org-popup-li {
  padding-left: $space-4x;
  padding-right: $space-4x;
}

.sidebar-toggle-button {
  @apply fixed top-1/2 -translate-y-1/2 transition-all duration-300 hidden md:block;
  z-index: 5;
  @apply border border-gray-200 rounded-lg rounded-l-none;
  @apply border-l-0;
}


</style>
